/** @type {import('vuex').GetterTree<neptune.payment.ach.IAchState, neptune.IRootState>} */
const getters = {};

export default getters;
